import axios from 'axios';

const EmailMobileVerificationService = {
  sendCode: (endpoint, path, contactDetail, type) =>
    axios.post(
      `${endpoint}${path}`,
      {
        contactMethod: type === 'email' ? 'Email' : 'SMS',
        purpose: 'VerifyApplicant',
        contactDetail
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ),
  verifyCode: (endpoint, path, contactDetail, code, type) =>
    axios.post(
      `${endpoint}${path}`,
      {
        contactMethod: type === 'email' ? 'Email' : 'SMS',
        purpose: 'VerifyApplicant',
        contactDetail,
        code
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
};

export default EmailMobileVerificationService;
